import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center app-surface bg-dot-grid p-6">
      <div className="text-center max-w-md">
        <div className="mx-auto mb-6 w-14 h-14 rounded-full bg-muted flex items-center justify-center">
          <Compass className="h-7 w-7 text-primary" />
        </div>
        <p className="text-sm font-mono text-muted-foreground mb-2">404</p>
        <h1 className="font-display text-3xl md:text-4xl font-semibold mb-3 tracking-tight">
          Page not found
        </h1>
        <p className="text-muted-foreground mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button asChild className="shadow-fluent-2">
          <Link to="/" className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Return to home
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
